import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

const TooltipOnHover = ({ msg, target }) => {
  return (
    <UncontrolledTooltip
      role="tooltip"
      id={`${target}Content`}
      target={target}
      className="info-tooltip"
      dangerouslySetInnerHTML={{__html:msg}}>
    </UncontrolledTooltip>
  );
};

export default TooltipOnHover;
